/* eslint-disable no-unused-vars */
import XLSX from "xlsx";
import shortID from "uuid/v4";

export const writeXLSX = (data, cols, sheetName) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, `${sheetName}.xlsx`);
};
export const parseXLSX = (input, fileType, readAsBinaryString) => {
    let data = input;
    if (
        fileType === "application/vnd.ms-excel" ||
        fileType ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
        data = new Uint8Array(input);
        let binary = "";
        let length = data.byteLength;
        for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(data[i]);
        }
        data = binary;
    }

    const workbook = XLSX.read(data, {
        type: readAsBinaryString ? "binary" : "string",
        cellDates: true
    });
    const [cols, ...rows] = XLSX.utils.sheet_to_json(
        workbook.Sheets[workbook.SheetNames[0]],
        {
            header: 1
        }
    );
    const result = rows.map((_, index) => {
        const dataObj = {};
        cols.map((colName, i) => (dataObj[colName] = _[i]));
        dataObj.key = shortID();
        return dataObj;
    });
    return result;
};

export const readSpreadsheet = file => {
    return new Promise(resolve => {
        let reader = new FileReader();
        let readAsBinaryString = false;
        if (
            file.type === "application/vnd.ms-excel" ||
            file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
            readAsBinaryString = true;
        }
        reader.onload = evt => {
            let data = parseXLSX(
                evt.target.result,
                file.type,
                readAsBinaryString
            );
            resolve(data);
        };
        if (readAsBinaryString) {
            reader.readAsArrayBuffer(file);
        } else {
            reader.readAsText(file);
        }
    });
};
